import { useParams } from "react-router-dom";

import {
  confirmAppointmentToken,
  confirmAppointmentTokenKey,
} from "modules/appointment/api/confirmAppointmentToken";
import { IAppointmentActionResponse } from "modules/appointment/types/IAppointmentActionResponse";

import { useGetFriendlyUrl } from "utils/hooks/useGetFriendlyUrl";

import { useReactQuery } from "components/RemoteData";
import { SuccessWidget } from "components/Widgets/SuccessWidget";
import { ChakraText } from "components/ChakraText";

import { TokenExpiredErrorBoundary } from "../Commons/TokenExpiredErrorBoundary";
import { ReservationDetails } from "../../Commons/ReservationDetails";
import { RedirectionButtons } from "../Commons/RedirectionButtons";

const AppointmentConfirmationPageThrowable = () => {
  const { friendlyUrl } = useGetFriendlyUrl();
  const { tokenId } = useParams<{
    tokenId: string;
  }>();

  const { data: appointment } = useReactQuery<IAppointmentActionResponse>(
    confirmAppointmentTokenKey(tokenId),
    () => confirmAppointmentToken(tokenId, friendlyUrl),
    {
      refetchOnWindowFocus: false,
    }
  );

  return (
    <>
      <SuccessWidget>
        <ChakraText alignSelf="center" fontSize={{ base: "xl", md: "3xl" }}>
          Pomyślnie zarezerwowano wizytę
        </ChakraText>
      </SuccessWidget>
      {appointment && <ReservationDetails appointment={appointment} />}
      <RedirectionButtons />
    </>
  );
};

const AppointmentConfirmationPage = () => {
  return (
    <TokenExpiredErrorBoundary>
      <AppointmentConfirmationPageThrowable />
    </TokenExpiredErrorBoundary>
  );
};

export default AppointmentConfirmationPage;
